<template>
  <div class="dynamicindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检测模板详情列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/checkinfo/create')"
          >创建模板</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <!-- 类型下拉 -->
        <!-- <el-col :span="5">
          <el-select
            class="select"
            clearable
            v-model="deviceTypeValue"
            placeholder="请选择设备类型"
            @change="changeDeviceType"
          >
            <el-option
              v-for="item in deviceTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="9">
          <el-input
            placeholder="请输入事项名称"
            v-model="itemName"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="infoLists" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeInfos"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { infoList, deleteInfo, updateInfo } from '@/api/checkinfo'
import { queryEquipment } from '@/api/dictionary'
import { scriptList } from '@/api/scriptis'

import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      itemName: '',
      deviceTypeValue: '',
      editState: false,
      editUnit: {},
      itemList: [],
      resultList: [],
      scriptList: [],
      infoLists: [],
      columns: [
        {
          field: 'sort',
          title: '序号'
        },
        {
          field: 'itemType',
          title: '事项类型'
        },
        {
          field: 'itemName',
          title: '事项名称'
        },
        // {
        //   field: 'resultType',
        //   title: '检测结果类型'
        // },
        {
          field: 'resultValue',
          title: '检测结果默认值'
        },
        {
          field: 'qualifiedType',
          title: '检测合格类型'
        },
        {
          field: 'status',
          title: '状态'
        },

        {
          field: 'shows',
          title: '是否在第一页显示'
        },

        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                let edirArr = JSON.parse(JSON.stringify(row))
                edirArr['status'] = edirArr['status'] === '启用' ? 1 : 2
                edirArr['shows'] = edirArr['shows'] === '是' ? 0 : 1
                edirArr['qualifiedType'] =
                  edirArr['qualifiedType'] === '一般' ? 0 : 1
                edirArr['resultType'] = edirArr['resultType'] === '选择' ? 1 : 2
                this.editUnit = edirArr
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  created() {
    this.queryEquipmentFn()
    this.getScriptList()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getCheckinfoList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getCheckinfoList()
    },
    //获取类型
    queryEquipmentFn() {
      let types = ['check_resultValue', 'check_itemType']
      queryEquipment(types).then((res) => {
        console.log(res.data, '类型')
        this.itemList = res.data.check_itemType
        this.resultList = res.data.check_resultValue
      })
    },
    // 获取检测项判定脚本列表
    getScriptList() {
      let params = {
        pageSize: -1
      }
      scriptList(params).then((res) => {
        if (res.code == 200) {
          let scriptArr = res.data.records
          this.scriptList = scriptArr.map((item) => {
            return {
              value: item.id,
              label: item.scriptName
            }
          })
        }
      })
    },
    // 列表
    getCheckinfoList() {
      let params = {
        itemName: this.itemName,
        deviceType: this.deviceTypeValue,
        pageSize: this.size,
        pageNum: this.page
      }
      infoList(params).then((res) => {
        if (res.code == 200) {
          let infoArr = res.data.records
          this.total = res.data.total
          this.infoLists = infoArr.map((item) => {
            return {
              id: item.id,
              sort: item.sort,
              itemName: item.itemName,
              itemType: item.dictName_itemType,
              resultType: Number(item.resultType) === 1 ? '选择' : '判定',
              resultValue: item.dictName_resultValue,
              shows: Number(item.shows) === 0 ? '是' : '否',
              scriptId: item.scriptId,
              qualifiedType: Number(item.qualifiedType) === 0 ? '一般' : '保证',
              status: Number(item.status) === 1 ? '启用' : '禁用'
            }
          })
        }
      })
    },

    // 编辑
    changeInfos(infos) {
      console.log(infos)
      this.$loading({
        text: '模板更新中'
      })
      let scripts = this.scriptList.find((el) => el.label === infos.scriptId)
      if (scripts) infos.scriptId = scripts.value
      let results = this.resultList.find((el) => el.label === infos.resultValue)
      if (results) infos.resultValue = results.value
      let items = this.itemList.find((el) => el.label === infos.itemType)
      if (items) infos.itemType = items.value
      console.log(infos)

      let updateparams = {
        ...infos
      }
      updateInfo(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getCheckinfoList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteInfo(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getCheckinfoList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getCheckinfoList()
    }
  },
  mounted() {
    this.getCheckinfoList()
  }
}
</script>

<style></style>
